/*
 * Copyright 2022. NXGN Management, LLC. All Rights Reserved.
 */

import { Address } from "./address";

export interface MerchantUserRoles {
  merchantId: number;
  practicestaffId: number;
  merchantName?: string;
  merchantAddres?: Address;
  merchantPhoneNumber?: string;
  locationCode?: string;
  userName: string;
  roles: string[];
  customerId?: number;
  feeSettlementType?: string;
}
